/**
 * Jobs API helpers.
 */

import { apiClient } from "../client";
import {
  JobAd,
  JobAdCreateResponse,
  JobAdCreateResponseSchema,
  JobAdListResponseSchema,
  JobAdSchema,
} from "../../validators/jobs";

export async function listJobAds(): Promise<{ results: JobAd[]; count: number }> {
  const res = await apiClient.get("/api/jobs/");
  return JobAdListResponseSchema.parse(res.data);
}

export async function getJobAd(uuid: string): Promise<JobAd> {
  const res = await apiClient.get(`/api/jobs/${uuid}/`);
  return JobAdSchema.parse(res.data);
}

export async function createJobFromUrl(url: string): Promise<JobAdCreateResponse> {
  const res = await apiClient.post("/api/jobs/from-url/", { url });
  return JobAdCreateResponseSchema.parse(res.data);
}

export async function createJobFromText(
  text: string,
  source_url?: string
): Promise<JobAdCreateResponse> {
  const res = await apiClient.post("/api/jobs/from-text/", { text, source_url });
  return JobAdCreateResponseSchema.parse(res.data);
}

export async function createJobFromFile(file: File): Promise<JobAdCreateResponse> {
  const form = new FormData();
  form.append("file", file);
  const res = await apiClient.post("/api/jobs/from-file/", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return JobAdCreateResponseSchema.parse(res.data);
}

export async function updateJobAd(uuid: string, data: { source_url?: string }): Promise<JobAd> {
  const res = await apiClient.patch(`/api/jobs/${uuid}/`, data);
  return JobAdSchema.parse(res.data);
}

export async function deleteJobAd(uuid: string): Promise<void> {
  await apiClient.delete(`/api/jobs/${uuid}/`);
}
